<template>
    <div ref="auth_panel" class="the-navbar__user-meta flex items-center">
        <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ displayText }}</p>
            <small>{{ userStatus }}</small>
        </div>

        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
                <img
                    key="offlineImg"
                    src="@/assets/images/team-placeholder.png"
                    alt="user-img"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"
                />
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 9rem;">
                    <div v-for="(item, index) in authorizedItems" :key="index">
                        <vs-divider v-if="item.isDivider" class="m-1" />
                        <li
                            v-else
                            :disabled="$route.fullPath != item"
                            @click="item.onClick"
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        >
                            <feather-icon :icon="item.icon" svgClasses="w-4 h-4" />
                            <span class="ml-2">{{ item.text }}</span>
                        </li>
                    </div>
                </ul>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            menuItems: [
                {
                    requireAuth: true,
                    text: 'Profile',
                    icon: 'UserIcon',
                    onClick: this.goToProfile
                },

                // {
                //     isDivider: true
                // },
                {
                    requireAuth: true,
                    text: 'Logout',
                    icon: 'LogOutIcon',
                    onClick: this.logout
                },
                {
                    requireAuth: false,
                    requireRole: [],
                    text: 'Login',
                    icon: 'LogInIcon',
                    onClick: this.login
                }
            ]
            // organisation: null
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'auth/current_user'
        }),
        authorizedItems() {
            return this.menuItems.filter((item) => {
                if (this.authenticated === item.requireAuth) {
                    if (this.hasRole(item.requireRole)) {
                        return true
                    }
                    return false
                } else if (item.requireAuth == null) {
                    return true
                }
                return false
            })
        },
        displayText() {
            if (this.authenticated) {
                return this.currentUser.firstName
            }
            return 'Sign In'
        },
        userStatus() {
            return this.authenticated ? 'Signed In' : 'Offline'
        }
    },
    methods: {
        hasRole(roles) {
            return this.$store.getters['auth/has_role'](roles)
        },
        goToProfile() {
            if (this.$route.fullPath != '/profile') {
                this.$router.push('/profile')
            }
        },
        async logout() {
            this.startLoad()
            this.$store.dispatch('auth/logout').then(() => this.endLoad())
        },
        login() {
            this.$router.push('/account/login')
        }
    }
}
</script>
